import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Header } from 'semantic-ui-react';
const DashboardButton = props => {
    return (
        <a id={props.id} href={props.href} onClick={props.onClick} className={`button ${props.color} ${props.className}`} style={{ cursor: 'pointer'}}>
            <div className="section">
                {props.fontawesomeIcon && <div>fontawesome</div>}
                {props.icon && <Icon name={props.icon} size={props.size} />}
                <div className="name">{props.name}</div>
                {props.content ? <div className="content">{props.content}</div> : ""}
            </div>
            {props.label || props.children ? 
            <div className="section">
                <div>
                    <Header as="h3" content={props.label} />
                    {props.children}
                </div> 
            </div>
            : ""}
        </a>
    );
};

DashboardButton.propTypes = {
    icon: PropTypes.string,
    fontawesomeIcon: PropTypes.string,
    color: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    name: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.node,
    content: PropTypes.node,
    className: PropTypes.string,
    href: PropTypes.string,
    onClick: PropTypes.func,
    onContentClick: PropTypes.func,
};

export default DashboardButton;